export const SEND_REFERRAL_CODE_REQUEST = 'SEND_REFERRAL_CODE_REQUEST';
export const SEND_REFERRAL_CODE_SUCCESS = 'SEND_REFERRAL_CODE_SUCCESS';
export const SEND_REFERRAL_CODE_FAILURE = 'SEND_REFERRAL_CODE_FAILURE';

export const CHECK_REFERRAL_CODE_REQUEST = 'CHECK_REFERRAL_CODE_REQUEST';
export const CHECK_REFERRAL_CODE_SUCCESS = 'CHECK_REFERRAL_CODE_SUCCESS';
export const CHECK_REFERRAL_CODE_FAILURE = 'CHECK_REFERRAL_CODE_FAILURE';
